<script setup>
import { computed } from 'vue';
import { stateName } from '../utils/brazilianStates';

const props = defineProps({
  data: {
    type: Object,
    default: () => ({ losing: [], mobilizable: [], grow: [] }),
  },
});

const buckets = computed(() => [
  {
    key: 'losing',
    title: 'Onde estou perdendo',
    subtitle: 'Sentimento líquido negativo — atenção urgente',
    icon: 'i-lucide-trending-down',
    headerClass: 'bg-gradient-to-br from-rose-500 to-red-600 text-white',
    items: props.data.losing || [],
  },
  {
    key: 'mobilizable',
    title: 'Apoio mobilizável',
    subtitle: 'Sentimento positivo mas volume ainda baixo',
    icon: 'i-lucide-megaphone',
    headerClass: 'bg-gradient-to-br from-emerald-500 to-teal-600 text-white',
    items: props.data.mobilizable || [],
  },
  {
    key: 'grow',
    title: 'Oportunidade de crescer',
    subtitle: 'Pouca presença — territórios sub-representados',
    icon: 'i-lucide-sprout',
    headerClass: 'bg-gradient-to-br from-blue-500 to-indigo-600 text-white',
    items: props.data.grow || [],
  },
]);
</script>

<template>
  <div class="grid grid-cols-1 gap-3 lg:grid-cols-3">
    <div
      v-for="b in buckets"
      :key="b.key"
      class="overflow-hidden rounded-xl border border-n-strong/40 bg-n-background"
    >
      <div :class="[b.headerClass, 'px-4 py-3']">
        <div class="flex items-center gap-2">
          <span :class="b.icon" class="size-4" />
          <h3 class="text-sm font-bold">{{ b.title }}</h3>
        </div>
        <p class="mt-0.5 text-[10px] opacity-90">{{ b.subtitle }}</p>
      </div>

      <div v-if="b.items.length" class="p-3">
        <ul class="space-y-1.5">
          <li
            v-for="i in b.items"
            :key="i.state"
            class="flex items-center justify-between rounded-md border border-n-weak/60 bg-n-slate-1 px-2 py-1.5"
          >
            <div class="min-w-0 flex-1">
              <p class="truncate text-xs font-semibold text-n-slate-12">
                {{ i.state }} — {{ stateName(i.state) }}
              </p>
              <p class="text-[10px] text-n-slate-11">
                {{ i.total }} menções · eng {{ i.engagement }}
              </p>
            </div>
            <span
              :class="[
                i.sentimentNet >= 0
                  ? 'bg-emerald-100 text-emerald-700'
                  : 'bg-rose-100 text-rose-700',
                'rounded px-1.5 py-0.5 text-[10px] font-bold',
              ]"
            >
              {{ i.sentimentNet > 0 ? '+' : '' }}{{ i.sentimentNet }}%
            </span>
          </li>
        </ul>
      </div>

      <div v-else class="py-6 text-center text-[11px] text-n-slate-11">
        Nenhum território neste bucket.
      </div>
    </div>
  </div>
</template>
